var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-page",class:{
  'list-state': _vm.mobileState === _vm.mobileChatStates.LIST,
  'chat-state': _vm.mobileState === _vm.mobileChatStates.CHAT,
  'info-state': _vm.mobileState === _vm.mobileChatStates.INFO,
}},[_c('ChatList',{staticClass:"chat-list-section"}),_c('ChatDialog',{staticClass:"chat-dialog-section"}),_c('ChatInfo',{staticClass:"chat-info-section"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }